import React, { useEffect, useState } from "react";
import { getData } from "../../utils/api";
import config from "../../config";
import "react-quill/dist/quill.snow.css";

import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import createCustomSchema from "../../fieldValidator/fieldValidator";
import { companyID } from "./../../auth";
import api from "../../api/axios";
import {
  getPolicyType,
  savePolicyData,
  updatePolicyVersion,
} from "../../services/policyServices";
import Swal from "sweetalert2";

const AddandEditPolicy = ({
  policy,
  setPolicyData,
  selectedDesignationtId,
  selectedDepartmentId,
  isModalOpen,
  setIsModalOpen,
  isEditModalOpen,
  setIsEditModalOpen,
  setPolicyEditData,
  updateVersion,
  setUpdateVersion,
}) => {
  const company_ID = companyID();
  const employeeID = localStorage.getItem("employeeID");
  const location = useLocation();
  const navigate = useNavigate();
  const [policyCategory, setPolicyCategory] = useState([]);
  const [policyCategoryName, setPolicyCategoryName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [policyType, setPolicyType] = useState([]);

  const [text, setText] = useState("");
  const [previousVersion, setPreviousVersion] = useState("");
  const [loading, setLoading] = useState(false);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#ff9b44" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "#ff9b44",
      },
    }),
  };

  const defaultPolicyDetails = {
    policy_name: "",
    generated_policy_content: "",
    policy_category_id: "",
    policy_file: null,
    policy_type_id: null,
    version_number: null,
  };

  const [policyDetails, setPolicyDetails] = useState(defaultPolicyDetails);

  const validationSchema = Yup.object({
    policy_name: createCustomSchema("text", {
      message: "Please Enter Policy Name!",
      min: 3,
    }),

    policy_category_id: createCustomSchema("dropdown", {
      message: "Please Select Policy Category!",
    }),
    policy_file: createCustomSchema("file", {
      message: "Please Select Policy File!",
    }),
    policy_type_id: createCustomSchema("dropdown", {
      message: "Please Select Policy Type!",
    }),
    version_number: createCustomSchema("paragraph", {
      message: "Please Enter Version Number!",
      min: 1,
      max: 10,
    }),
  });

  const [editorContent, setEditorContent] = useState("");

  const handleEditorChange = (content) => {
    setEditorContent(content);
    if (content == "<p><br></p>") {
      setPolicyDetails({ ...policyDetails, generated_policy_content: "" });
      setEditorContent("");
      return;
    }
    setPolicyDetails({ ...policyDetails, generated_policy_content: content });
  };

  const handleTextChange = (content) => {
    setText(content);
    if (content == "<p><br></p>") {
      setPolicyDetails({ ...policyDetails, generated_policy_content: "" });
      setEditorContent("");
      return;
    }
    setPolicyDetails({ ...policyDetails, generated_policy_content: content });
  };

  const [policyDetailsError, setPolicyDetailsError] = useState({});

  const policyHandler = async (e) => {
    const { name, value } = e.target;
    if (name === "version_number") {
      if (value === previousVersion) {
        setPolicyDetailsError({
          ...policyDetailsError,
          version_number: "Version cannot be the same as the previous version.",
        });
        setPolicyDetails({ ...policyDetails, [name]: value });
        return;
      }
    }
    setPolicyDetails({ ...policyDetails, [name]: value });

    const newPolicyDetails = {
      ...policyDetails,
      [name]: value,
    };

    try {
      await validationSchema.validateAt(name, newPolicyDetails);
      setPolicyDetailsError((prevErrors) => ({ ...prevErrors, [name]: "" }));
    } catch (err) {
      setPolicyDetailsError((prevErrors) => ({
        ...prevErrors,
        [name]: err.message,
      }));
    }
  };
  const policyData = async (e) => {
    try {
      const res = await getData("hr");
      const filteredData = res?.data?.results?.filter(
        (policy) => policy?.status === 1
      );
      setPolicyData(filteredData);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (policy) {
      setPolicyDetails({ ...policy[0] });
      setPreviousVersion(policy[0]?.version_number ?? "");
    }
  }, [policy]);

  const policyHandlerFile = (e) => {
    setPolicyDetails({ ...policyDetails, policy_file: e.target.files[0] });
  };

  const policyEditSubmitHandler = async () => {
    setLoading(true);
    try {
      const policyHandling = {
        policy_name: validationSchema.fields.policy_name,
        policy_category_id: validationSchema.fields.policy_category_id,
      };

      const dynamicSchema = Yup.object().shape(
        Object.keys(policyDetails).reduce((acc, key) => {
          if (policyHandling[key]) {
            acc[key] = policyHandling[key];
          } else if (policyDetails[key]) {
            acc[key] = validationSchema.fields[key];
          }
          return acc;
        }, {})
      );

      await dynamicSchema.validate(policyDetails, {
        abortEarly: false,
      });
      const formData = new FormData();
      for (const key in policyDetails) {
        if (key != "updated_by") {
          formData.append(key, policyDetails[key]);
        }
      }
      formData.append(
        "departments",
        selectedDepartments?.filter((department) => department !== null)
      );
      formData.append(
        "designations",
        selectedDesignations?.filter((designation) => designation !== null)
      );
      formData.append("updated_by", employeeID);
      const res = await api.put(
        `hr/upload-policy/${policyDetails?.id}`,
        formData
      );
      if (res?.data?.succee === true) {
        navigate(`${location?.pathname}`);
        policyData();
        setErrorMessage("");
        Swal.fire({
          title: "Policy",
          text: "Policy edited successfully",
          timer: 1500,
          icon: "success",
        });
        closeEditModal();
      }
    } catch (error) {
      console.error(error);
      const newError = {};
      error?.inner?.forEach((err) => {
        newError[err.path] = err.message;
      });
      Swal.fire({
        title: "Policy",
        text: "Something went wrong!",
        timer: 1500,
        icon: "warning",
      });
      setPolicyDetailsError(newError);
    } finally {
      setLoading(false);
    }
  };

  const policyCateroryHandler = async (e, id) => {
    setPolicyDetails({ ...policyDetails, policy_category_id: id });
    setPolicyCategoryName(e.target.value);

    const newPolicyDetails = {
      ...policyDetails,
      policy_category_id: id,
    };

    try {
      await validationSchema.validateAt("policy_category_id", newPolicyDetails);
      setPolicyDetailsError((prevErrors) => ({
        ...prevErrors,
        ["policy_category_id"]: "",
      }));
    } catch (err) {
      setPolicyDetailsError((prevErrors) => ({
        ...prevErrors,
        ["policy_category_id"]: err.message,
      }));
    }
  };

  const [department, setDepartment] = useState([]);

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const departmentResponse = await api.get(`department/${company_ID}`);
        setDepartment(departmentResponse.data.result);
        const query = isModalOpen ? company_ID : null;
        const policyTypeResponse = await getPolicyType(query);
        setPolicyType(policyTypeResponse?.policyTypes);

        const policyCategoryResponse = await api.get(`hr/policy-category`);
        setPolicyCategory(policyCategoryResponse?.data?.results);
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };

    fetchInitialData();
  }, []);

  const [selectedDepartments, setSelectedDepartments] = useState([]);

  const handleDepartmentSelection = (e) => {
    const id = parseInt(e.target.value);
    if (selectedDepartments?.includes(id)) {
      setSelectedDepartments(
        selectedDepartments?.filter((depId) => depId !== id)
      );
    } else {
      setSelectedDepartments([...selectedDepartments, id]);
    }
  };

  const [selectedDesignations, setSelectedDesignations] = useState([]);

  const handleDesignationSelection = (e) => {
    const id = parseInt(e.target.value);
    if (selectedDesignations?.includes(id)) {
      setSelectedDesignations(
        selectedDesignations?.filter((desId) => desId !== id)
      );
    } else {
      setSelectedDesignations([...selectedDesignations, id]);
    }
  };

  const [designation, setDesignation] = useState([]);

  useEffect(() => {
    const fetchDesignationsForDepartments = async () => {
      try {
        const response = await fetch(
          `${
            config.API_BASE_URL
          }hr/api/designations?departments=${selectedDepartments.join(",")}`
        );
        const data = await response.json();
        setDesignation(data?.designations);
        setSelectedDesignations(
          selectedDesignations?.filter((desId) =>
            data?.designations.some((designation) => designation.id === desId)
          )
        );
      } catch (error) {
        console.error("Error fetching designations:", error);
        return [];
      }
    };
    if (
      selectedDepartments?.filter((department) => department !== null)
        .length !== 0
    ) {
      fetchDesignationsForDepartments();
    }
  }, [selectedDepartments]);

  const closeModal = () => {
    setIsModalOpen(false);
    resetDetails();
  };

  const policySubmitHandler = async () => {
    setLoading(true);
    try {
      const policyHandling = {
        policy_name: validationSchema.fields.policy_name,
        policy_category_id: validationSchema.fields.policy_category_id,
      };

      const dynamicSchema = Yup.object().shape(
        Object.keys(policyDetails).reduce((acc, key) => {
          if (policyHandling[key]) {
            acc[key] = policyHandling[key];
          } else if (policyDetails[key]) {
            acc[key] = validationSchema.fields[key];
          }
          return acc;
        }, {})
      );

      await dynamicSchema.validate(policyDetails, {
        abortEarly: false,
      });

      const formData = new FormData();
      for (const key in policyDetails) {
        formData.append(key, policyDetails[key]);
      }
      formData.append("company_id", company_ID);
      formData.append("created_by", employeeID);
      formData.append("updated_by", employeeID);
      formData.append(
        "departments",
        selectedDepartments?.filter((department) => department !== null)
      );
      formData.append(
        "designations",
        selectedDesignations?.filter((designation) => designation !== null)
      );
      const res = await savePolicyData(formData);
      if (res.succee == true) {
        setErrorMessage("");
        Swal.fire({
          title: "Policy",
          text: "Policy added successfully",
          timer: 1500,
          icon: "success",
        });
        closeModal();
      }
      if (res?.success === false) {
        setErrorMessage(res?.message);
      }
    } catch (error) {
      console.error(error);
      const newError = {};
      error?.inner?.forEach((err) => {
        newError[err.path] = err.message;
      });
      Swal.fire({
        title: "Policy",
        text: "Something went wrong!",
        timer: 1500,
        icon: "warning",
      });
      setPolicyDetailsError(newError);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setSelectedDepartments(selectedDepartmentId);
    setSelectedDesignations(selectedDesignationtId);
  }, [selectedDepartmentId, selectedDesignationtId]);

  const resetDetails = () => {
    setPolicyDetails(defaultPolicyDetails);
    setPolicyCategoryName("");
    setSelectedDepartments([]);
    setSelectedDesignations([]);
    setEditorContent("");
    setPolicyData([]);
    setPolicyEditData([]);
    setDepartment([]);
    setDesignation([]);
    setPolicyDetailsError({});
    setText("");
    setErrorMessage("");
    setPolicyType([]);
    setPolicyCategory([]);
    setPreviousVersion("");
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setUpdateVersion(false);
    resetDetails();
  };

  const filterDepartmentNames = (ids, departments) => {
    const departmentIdSet = new Set(ids);
    return departments
      ?.filter((department) => departmentIdSet.has(department.id))
      .map((department, index) =>
        index == 0
          ? department.department_name
          : ", " + department.department_name
      );
  };

  const filterDesignation = (ids, designation) => {
    const designationIdSet = new Set(ids);
    if (designation) {
      return designation
        ?.filter((designation) => designationIdSet.has(designation.id))
        .map((designation, index) =>
          index == 0
            ? designation.designation_name
            : ", " + designation.designation_name
        );
    }
  };

  const updatePolicyVersionHandler = async (policyId) => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("policy_file", policyDetails.policy_file);
      formData.append("updated_by", employeeID);
      formData.append("version_number", policyDetails.version_number);
      formData.append(
        "generated_policy_content",
        policyDetails.generated_policy_content
      );
      formData.append("policy_category_id", policyDetails.policy_category_id);
      formData.append("policy_type_id", policyDetails.policy_type_id);
      formData.append("company_id", company_ID);

      const response = await updatePolicyVersion(policyId, formData);
      if (response.success) {
        setErrorMessage("");
        Swal.fire({
          title: "Policy",
          text: "Policy updated successfully",
          timer: 1500,
          icon: "success",
        });
        closeEditModal();
      } else {
        setErrorMessage(response.message);
      }
    } catch (error) {
      console.error("Error updating policy version:", error);
      Swal.fire({
        title: "Policy",
        text: "Something went wrong!",
        timer: 1500,
        icon: "warning",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Add Policy Modal */}
      <div
        id="add_policy"
        className={`modal custom-modal fade ${
          isModalOpen ? "show d-block" : ""
        }`}
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Policy</h5>
              <button type="button" className="btn-close" onClick={closeModal}>
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form method="POST" onSubmit={(e) => e.preventDefault()}>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Category <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    styles={customStyles}
                    placeholder="Select"
                    name="gender"
                    id="policy_dropdown"
                    value={
                      policyCategoryName
                        ? policyCategoryName
                        : policyDetails.policy_category_id
                    }
                    onChange={(event) =>
                      policyCateroryHandler(
                        event,
                        event.target.selectedOptions[0].getAttribute("data-id")
                      )
                    }
                  >
                    {" "}
                    <option value="">Select Category</option>
                    {policyCategory.map((item) => (
                      <option
                        value={item.id}
                        key={item.policy_type}
                        data-id={item.id}
                      >
                        {item.policy_type}
                      </option>
                    ))}
                  </select>
                  {policyDetailsError.policy_category_id && (
                    <span className="text-danger">
                      *{policyDetailsError.policy_category_id}
                    </span>
                  )}
                </div>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Policy <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="policy_type_id"
                    value={policyDetails.policy_type_id}
                    onChange={(e) => policyHandler(e)}
                  >
                    <option value="">Select Policy</option>
                    {policyType.map((type) => (
                      <option key={type.id} value={type.id}>
                        {type.name}
                      </option>
                    ))}
                  </select>
                  {policyDetailsError.policy_type_id && (
                    <span className="text-danger">
                      *{policyDetailsError.policy_type_id}
                    </span>
                  )}
                </div>

                <div className="input-block mb-3">
                  <label className="col-form-label">Department</label>
                  <div className="dropdown">
                    <button
                      className="btn  dropdown-toggle w-100 text-start"
                      id="departmentDropdown"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style={{ border: "1px solid gray" }}
                    >
                      Select Department(s)
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="departmentDropdown"
                    >
                      {department?.map((department) => (
                        <li key={department.id} className="text-danger">
                          <label className="dropdown-item">
                            <input
                              type="checkbox"
                              value={department.id}
                              onChange={(e) => handleDepartmentSelection(e)}
                            />
                            {department.department_name}
                          </label>
                        </li>
                      ))}
                    </ul>
                    <span>
                      {filterDepartmentNames(selectedDepartments, department)}
                    </span>
                  </div>

                  {policyDetailsError.departments && (
                    <span className="text-danger">
                      *{policyDetailsError.departments}
                    </span>
                  )}
                </div>

                {selectedDepartments?.length ? (
                  <div className="input-block mb-3">
                    <label className="col-form-label">Designation</label>
                    <div className="dropdown">
                      <button
                        className="btn  dropdown-toggle w-100 text-start"
                        id="departmentDropdown"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        style={{ border: "1px solid gray" }}
                      >
                        Select Designation
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="designationDropdown"
                      >
                        {designation?.map((designation) => (
                          <li key={designation.id}>
                            <label className="dropdown-item">
                              <input
                                type="checkbox"
                                name="designation"
                                value={designation.id}
                                onChange={(e) => handleDesignationSelection(e)}
                              />{" "}
                              {filterDepartmentNames(
                                [designation.department_id],
                                department
                              )}{" "}
                              - {designation.designation_name}
                            </label>
                          </li>
                        ))}
                      </ul>
                      <span>
                        {filterDesignation(selectedDesignations, designation)}
                      </span>
                    </div>
                    {policyDetailsError.designation && (
                      <span className="text-danger">
                        *{policyDetailsError.designation}
                      </span>
                    )}
                  </div>
                ) : (
                  <></>
                )}

                <div className="input-block mb-3">
                  <label className="col-form-label">
                    {updateVersion ? "New" : "Policy"} Version{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="version_number"
                    value={policyDetails.version_number || ""}
                    onChange={(e) => policyHandler(e)}
                    placeholder="Enter Version Number"
                  />
                  <span className="tex-secondary col-form-label">
                    eg: V1.0{" "}
                  </span>
                  {policyDetailsError.version_number && (
                    <span className="text-danger">
                      *{policyDetailsError.version_number}
                    </span>
                  )}
                </div>

                {!policyDetails?.generated_policy_content && (
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Upload Policy <span className="text-danger">*</span>
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      id="policy_upload"
                      name="policy_file"
                      onChange={policyHandlerFile}
                      accept=".pdf"
                    />
                    <span
                      className="text-secondary "
                      style={{ fontSize: "12px" }}
                    >
                      {" "}
                      * File size must not exceed 500 KB.
                    </span>
                    {policyDetailsError.policy_file && (
                      <p className="text-danger">
                        *{policyDetailsError.policy_file}
                      </p>
                    )}
                  </div>
                )}
                <div className="submit-section">
                  <button
                    className="btn btn-primary submit-btn"
                    type="submit"
                    disabled={
                      policyDetails?.policy_type_id &&
                      (policyDetails?.policy_file ||
                        policyDetails?.generated_policy_content) &&
                      policyDetails?.policy_category_id &&
                      policyDetails?.version_number
                        ? false
                        : true
                    }
                    onClick={policySubmitHandler}
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Edit Policy Modal */}
      <div
        id="edit_policy"
        className={`modal custom-modal fade ${
          isEditModalOpen ? "show d-block" : ""
        }`}
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {updateVersion
                  ? "Update Policy Version"
                  : "Applicable Employees"}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={closeEditModal}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="d-flex justify-content-between mb-3">
                <div className="input-block">
                  <label className="col-form-label">Category: </label>
                  <p>
                    <span className="badge bg-warning">
                      {policyCategoryName ||
                        policyCategory?.find(
                          (item) =>
                            item.id === policyDetails?.policy_category_id
                        )?.policy_type ||
                        "N/A"}
                    </span>
                  </p>
                </div>

                <div className="input-block">
                  <label className="col-form-label">Policy:</label>
                  <p>
                    <span className="badge bg-warning">
                      {policyType?.find(
                        (item) => item.id === policyDetails?.policy_type_id
                      )?.name || "N/A"}
                    </span>
                  </p>
                </div>
              </div>

              <form onSubmit={(e) => e.preventDefault()}>
                <div
                  className={`${
                    updateVersion ? "d-flex justify-content-between" : ""
                  }`}
                >
                  <div className="input-block mb-3">
                    <label className="col-form-label">Previous Version: </label>
                    <p>
                      <span className="badge bg-info">
                        {previousVersion || "N/A"}
                      </span>
                    </p>
                  </div>

                  {updateVersion && (
                    <div className="input-block mb-3">
                      <label className="col-form-label">
                        {updateVersion ? "New" : "Policy"} Version{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="version_number"
                        value={policyDetails.version_number || ""}
                        onChange={(e) => policyHandler(e)}
                        placeholder="Enter Version Number"
                      />
                      {policyDetailsError.version_number && (
                        <span className="text-danger">
                          *{policyDetailsError.version_number}
                        </span>
                      )}
                    </div>
                  )}
                </div>
                {updateVersion ? (
                  <> </>
                ) : (
                  <>
                    {/* <div className="input-block mb-3">
                      <label className="col-form-label">
                        Category <span className="text-danger">*</span>
                      </label>

                      <select
                        className="form-select"
                        styles={customStyles}
                        placeholder="Select"
                        name="gender"
                        id="edit_policy_dropdown"
                        value={
                          policyCategoryName
                            ? policyCategoryName
                            : policyDetails.policy_category_id
                        }
                        onChange={(event) =>
                          policyCateroryHandler(
                            event,
                            event.target.selectedOptions[0].getAttribute(
                              "data-id"
                            )
                          )
                        }
                      >
                        {" "}
                        <option value="">Select Category</option>
                        {policyCategory.map((item) => (
                          <option
                            value={item.id}
                            key={item.policy_type}
                            data-id={item.id}
                          >
                            {item.policy_type}
                          </option>
                        ))}
                      </select>
                      {policyDetailsError.policy_category_id && (
                        <span className="text-danger">
                          *{policyDetailsError.policy_category_id}
                        </span>
                      )}
                    </div>

                    <div className="input-block mb-3">
                      <label className="col-form-label">
                        Policy <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select"
                        name="policy_type_id"
                        value={policyDetails.policy_type_id}
                        onChange={(e) => policyHandler(e)}
                      >
                        <option value="">Select Policy</option>
                        {policyType.map((type) => (
                          <option key={type.id} value={type.id}>
                            {type.name}
                          </option>
                        ))}
                      </select>
                      {policyDetailsError.policy_type_id && (
                        <span className="text-danger">
                          *{policyDetailsError.policy_type_id}
                        </span>
                      )}
                    </div> */}

                    <div className="input-block mb-3">
                      <label className="col-form-label">Department</label>
                      <div className="dropdown">
                        <button
                          className="btn  dropdown-toggle w-100 text-start"
                          id="departmentDropdown"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          style={{ border: "1px solid gray" }}
                        >
                          Select Department(s)
                        </button>
                        <ul
                          className="dropdown-menu"
                          aria-labelledby="departmentDropdown"
                        >
                          {department?.map((department) => (
                            <li key={department.id} className="text-danger">
                              <label className="dropdown-item">
                                <input
                                  type="checkbox"
                                  value={department.id}
                                  onChange={(e) => handleDepartmentSelection(e)}
                                  checked={selectedDepartments?.includes(
                                    department.id
                                  )}
                                />
                                {department.department_name}
                              </label>
                            </li>
                          ))}
                        </ul>
                        <span>
                          {filterDepartmentNames(
                            selectedDepartments,
                            department
                          )}
                        </span>
                      </div>
                      {policyDetailsError.departments && (
                        <span className="text-danger">
                          *{policyDetailsError.departments}
                        </span>
                      )}
                    </div>

                    {selectedDepartments?.length ? (
                      <div className="input-block mb-3">
                        <label className="col-form-label">Designation</label>
                        <div className="dropdown">
                          <button
                            className="btn  dropdown-toggle w-100 text-start"
                            id="departmentDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{ border: "1px solid gray" }}
                          >
                            Select Designation
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="designationDropdown"
                          >
                            {designation.map((designation) => (
                              <li key={designation.id}>
                                <label className="dropdown-item">
                                  <input
                                    type="checkbox"
                                    name="designation"
                                    value={designation.id}
                                    onChange={(e) =>
                                      handleDesignationSelection(e)
                                    }
                                    checked={selectedDesignations?.includes(
                                      designation.id
                                    )}
                                  />{" "}
                                  {filterDepartmentNames(
                                    [designation.department_id],
                                    department
                                  )}{" "}
                                  - {designation.designation_name}
                                </label>
                              </li>
                            ))}
                          </ul>
                          <span>
                            {filterDesignation(
                              selectedDesignations,
                              designation
                            )}
                          </span>
                        </div>
                        {policyDetailsError.designation && (
                          <span className="text-danger">
                            *{policyDetailsError.designation}
                          </span>
                        )}
                      </div>
                    ) : (
                      <></>
                    )}
                  </>
                )}

                {!policyDetails?.generated_policy_content && updateVersion && (
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Upload Policy <span className="text-danger">*</span>
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      id="edit_policy_upload"
                      name="policy_file"
                      onChange={policyHandlerFile}
                      accept=".pdf"
                    />
                  </div>
                )}
                {policyDetailsError.policy_file && (
                  <p className="text-danger">
                    *{policyDetailsError.policy_file}
                  </p>
                )}
                {policyDetails.policy_file &&
                !policyDetails?.generated_policy_content &&
                updateVersion ? (
                  <span>
                    {policyDetails?.policy_file?.name
                      ? policyDetails.policy_file?.name
                      : policyDetails.policy_file}
                  </span>
                ) : (
                  ""
                )}
                <div className="submit-section">
                  <button
                    className="btn btn-primary submit-btn"
                    disabled={
                      policyDetails?.policy_type_id &&
                      (policyDetails?.policy_file ||
                        policyDetails?.generated_policy_content) &&
                      policyDetails?.policy_category_id &&
                      policyDetails?.version_number
                        ? false
                        : true
                    }
                    onClick={() => {
                      if (updateVersion) {
                        updatePolicyVersionHandler(policyDetails?.id);
                      } else {
                        policyEditSubmitHandler();
                      }
                    }}
                    type="submit"
                  >
                    {loading
                      ? updateVersion
                        ? "Updating version..."
                        : "Saving changes..."
                      : updateVersion
                      ? "Update Version"
                      : "Save Changes"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddandEditPolicy;
